import { HTTP, httpPOST, httpGET, httpPATCH } from '@/services/http'
import cookies from '@/services/cookies'
// import config from '../../config'

// const API_URL = config.API_URL + '/v1'
const API_URL = 'https://assetanalysis-socketservices-mo7niavhjq-de.a.run.app/v1'
export const User = {
  hasPermission(permissionRoles, userRoles) {
    if (!permissionRoles || !permissionRoles.length || !userRoles || !userRoles.length) {
      return false
    }
    return permissionRoles.some(role => userRoles.filter(userRoleObj => userRoleObj.name === role).length)
  },
  /**
   * getAllUsers
   * @returns all the users in system
  **/
  getAllUsers() {
    return httpGET(`${API_URL}/users`)
  },

  /**
   * save
   * @returns saved user
  **/
  save(params) {
    return httpPOST(`${API_URL}/users`, params)
  },

  /**
   * update
   * @returns updates user
  **/
  updateById(id, params) {
    return httpPATCH(`${API_URL}/users/${id}`, params)
  },

  /* Login and reciece back JSON Web Token used to authenticate subsequent requests */
  login(params) {
    return httpPOST(`${API_URL}/users/login`, params)
  },
  resetPassword (params) {
    return httpPOST(`${API_URL}/users/reset-password`, params)
  },
  changePassword (params) {
    return httpPOST(`${API_URL}/users/change-password`, params)
  },
  forgotPassword (params) {
    return httpPOST(`${API_URL}/users/forgot-password`, params)
  },

  /**
   * Set the jwt_token cookie
   * @param jwtToken
   * @param jwtTokenExpiration - number of seconds until cookie should expire. Default is an hour.
   */
  setJWTTokenCookie(jwtToken, jwtTokenExpiration = 3600) {
    if (jwtToken) {
      cookies.set('jwt_token', jwtToken, jwtTokenExpiration)
      HTTP.defaults.headers.common['authorization'] = cookies.get('jwt_token')
    }
  },

  verifyToken() {
    if (!cookies.get('jwt_token')) throw new Error('Access Token is missing')
    return httpGET(`${API_URL}/users/verifyToken`)
  },

  clearTokenCookies() {
    cookies.delete('jwt_token')
  }
}
